/**
 * What privacy mode masks (D-260): who and what a record is about, how to reach them, money and
 * what was written — by the field's kind, unless the administrator said otherwise for a field
 * (settings → fields → privacy). What one finds one's way by stays readable: labels, statuses,
 * stages, dates, counts, colleagues.
 */

// Kinds of field masked as a rule.
const SENSITIVE_TYPES = ['string', 'text', 'textarea', 'richtext', 'money', 'email', 'phone', 'url', 'address', 'morph', 'json']
// Strings that name a kind of thing, not somebody.
const PLAIN_STRINGS = ['currency_code', 'delivery_status', 'recurrence_rule', 'registration_country', 'number', 'source', 'short_code']
// References to the records a client is in; not colleagues, groups, pipelines, products or templates.
const SENSITIVE_REFS = ['account', 'contact', 'lead', 'opportunity', 'offer', 'contract', 'agreement', 'activity', 'note']
// Fields shown by components of their own.
const ALWAYS = ['label', 'contact_points', 'addresses', 'regarding', 'noteable', 'parties', 'body', 'description', 'subject', 'end_customer', 'account', 'contact']
const NEVER = ['owner', 'tags', 'type', 'subtype', 'status', 'stage', 'pipeline', 'priority', 'is_private', 'template']

/** A custom field's kind as the list of standard kinds has it. */
const CUSTOM_TYPES = { text: 'string', textarea: 'text', richtext: 'richtext', money: 'money', email: 'email', phone: 'phone', url: 'url', lookup: 'ref', multilookup: 'ref', borrowed: 'string', computed: 'string' }

/** Whether a field is masked by its kind alone, before the administrator's choice. */
export function sensitiveByKind(meta, entity, name) {
  if (ALWAYS.includes(name)) return true
  if (NEVER.includes(name)) return false
  if (name.startsWith('cf.')) {
    const def = meta.customField(entity, name.slice(3))
    if (!def) return false
    const type = CUSTOM_TYPES[def.type]
    return type === 'ref' ? SENSITIVE_REFS.includes(def.target_entity) : SENSITIVE_TYPES.includes(type)
  }
  const field = meta.field(entity, name)
  if (!field) return false
  if (field.type === 'ref') return SENSITIVE_REFS.includes(field.ref)
  if (field.type === 'string') return !PLAIN_STRINGS.includes(name)
  return SENSITIVE_TYPES.includes(field.type)
}

/** Whether a field is masked: the administrator's choice, else by its kind. */
export function isSensitive(meta, entity, name) {
  const chosen = meta.data?.settings?.sensitive_fields?.[entity]?.[name]
  return typeof chosen === 'boolean' ? chosen : sensitiveByKind(meta, entity, name)
}
